module.exports = __webpack_public_path__ + "img/logo-ikea.9295734d.jpg";